import React from 'react';
import AuthDialogContextProvider from '../../front/components/AuthDialog/AuthDialogContextProvider';
import SagaContainer from './containers';

export type PlanProps = {
  id: number,
  favoriteCount: number,
  isFavorite: boolean,
  isAuthenticated: boolean,
  title: string,
};

export type ThumbnailProps = {
  id: number,
  thumbnail: string,
};

export type BusinessProps = {
  id: number,
  name: string,
  followerCount: number,
  isAuthenticated: boolean,
  isFollowing: boolean,
};

export type SagaProps = {
  plans: Array<PlanProps>,
  businesses: Array<BusinessProps>,
};

const Saga = (props: SagaProps) => {
  return (
    <AuthDialogContextProvider>
      <SagaContainer {...props} />
    </AuthDialogContextProvider>
  );
};

export default Saga;
